import Contact from '@/pages/home/components/Contact';

export default function Contacto() {
  return (
    <main className="min-h-screen bg-background-50">
      <Contact />
    </main>
  );
}